module.exports = __webpack_public_path__ + "static/lol-351aeed3877caae3b62263321ccd205c.png";